// extracted by mini-css-extract-plugin
export default {"error_page_section":"notFound_error_page_section__j2LZn"};